/**
 * Cart → MM Spin & Win.
 * Uses embedded MM_GAME_CONFIG + DOM — does NOT poll /api/game-session
 * (that flood exhausted Prisma connection_limit=1 on Render).
 */
(function () {
  'use strict';

  var armed = false;
  var opening = false;
  var closeWatch = 0;
  var knownActive = null;

  function isAr() {
    var lang =
      (document.documentElement && document.documentElement.lang) ||
      (window.Shopify && Shopify.locale) ||
      '';
    return String(lang).toLowerCase().indexOf('ar') === 0;
  }

  function cfg() {
    return window.MM_GAME_CONFIG || null;
  }

  function parseWheelRoot(raw) {
    if (!raw) return null;
    var root = raw;
    if (typeof root === 'string') {
      try {
        root = JSON.parse(root);
      } catch (e) {
        return null;
      }
    }
    if (root && root.value != null) root = root.value;
    return root;
  }

  /** Sync check from page-embedded config only (no network). */
  function configSaysActive() {
    var c = cfg();
    if (!c) return false;
    if (c.active === false || c.active === 'false' || c.active === 0) return false;

    var root = parseWheelRoot(c.wheelConfig);
    if (root) {
      if (root.active === false || root.active === 'false' || root.active === 0) return false;
      if (root.config && root.config.markets) {
        var cc = String(c.countryCode || 'BH').toUpperCase();
        var m = root.config.markets[cc];
        if (!m) return false;
        return m.isActive === true || m.isActive === 'true' || m.isActive === 1;
      }
      return root.active === true || root.active === 'true' || root.active === 1;
    }

    return c.active === true || c.active === 'true' || c.active === 1;
  }

  function domGameReady() {
    return !!(
      document.getElementById('mm-launch-btn') ||
      document.getElementById('mm-overlay') ||
      document.getElementById('mm-game-root')
    );
  }

  /**
   * Active if embed config says so, OR the wheel widget already mounted.
   * Never hits the API on a timer / MutationObserver / cart:updated loop.
   */
  function isWheelActive() {
    if (knownActive != null) return knownActive;
    if (configSaysActive()) {
      knownActive = true;
      return true;
    }
    if (domGameReady()) {
      knownActive = true;
      return true;
    }
    knownActive = false;
    return false;
  }

  function cartWheelBtn() {
    return document.getElementById('mmCartSheetWheelBtn');
  }

  function syncCartWheelBtn(active) {
    var btn = cartWheelBtn();
    if (!btn) return;
    if (active) {
      btn.hidden = false;
      btn.removeAttribute('hidden');
      btn.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-disabled', 'false');
      btn.title = btn.getAttribute('data-mm-wheel-title') || btn.getAttribute('aria-label') || '';
    } else {
      btn.hidden = true;
      btn.setAttribute('hidden', '');
      btn.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-disabled', 'true');
    }
  }

  function refreshBtnState() {
    /* Re-read config/DOM without network */
    knownActive = null;
    var active = isWheelActive();
    syncCartWheelBtn(active);
    if (active) hideFabOnly();
    return Promise.resolve(active);
  }

  function hideFabOnly() {
    if (armed || opening) return;
    var launch = document.getElementById('mm-launch-btn');
    if (launch) {
      launch.classList.add('mm-wheel-fab-hidden');
      launch.setAttribute('data-mm-wheel-trigger', '1');
    }
    var root = document.getElementById('mm-game-root');
    if (root) root.setAttribute('data-mm-wheel-host', '1');
  }

  function clearFabHidden() {
    var list = document.querySelectorAll('.mm-wheel-fab-hidden');
    for (var i = 0; i < list.length; i++) list[i].classList.remove('mm-wheel-fab-hidden');
  }

  function setFlags(openGame, isOpening) {
    var html = document.documentElement;
    var body = document.body;
    if (!html || !body) return;
    html.classList.toggle('mm-wheel-game-open', !!openGame);
    body.classList.toggle('mm-wheel-game-open', !!openGame);
    html.classList.toggle('mm-wheel-opening', !!isOpening);
    body.classList.toggle('mm-wheel-opening', !!isOpening);
    var sheet =
      document.getElementById('mm-cart-sheet') || document.getElementById('mm-cart-drawer-v2');
    if (sheet) {
      if (openGame) sheet.setAttribute('data-mm-wheel-under', '1');
      else sheet.removeAttribute('data-mm-wheel-under');
    }
  }

  function liftGame() {
    var nodes = [
      document.getElementById('mm-game-root'),
      document.getElementById('mm-overlay'),
      document.querySelector('.mm-game-widget-container')
    ];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i]) nodes[i].classList.add('mm-wheel-overlay-lift');
    }
  }

  function clearLift() {
    var nodes = document.querySelectorAll('.mm-wheel-overlay-lift');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.remove('mm-wheel-overlay-lift');
  }

  function toast(msg) {
    try {
      if (window.MMCart && typeof window.MMCart.showToast === 'function') {
        window.MMCart.showToast(msg, 'error');
        return;
      }
    } catch (e) {}
  }

  function gameOpen() {
    var ov = document.getElementById('mm-overlay');
    return !!(ov && ov.classList.contains('open'));
  }

  function openExistingGame() {
    clearFabHidden();
    setFlags(true, true);
    opening = true;

    var launch = document.getElementById('mm-launch-btn');
    var ov = document.getElementById('mm-overlay');

    if (launch) {
      try {
        launch.click();
      } catch (e) {
        try {
          launch.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        } catch (e2) {}
      }
    }
    if (ov) ov.classList.add('open');

    setTimeout(function () {
      opening = false;
      if (gameOpen() || ov) {
        armed = true;
        setFlags(true, false);
        liftGame();
        startCloseWatch();
        if (launch) launch.classList.add('mm-wheel-fab-hidden');
        return;
      }
      disarm(false);
    }, 200);

    setTimeout(liftGame, 400);
    return true;
  }

  function disarm(afterPrize) {
    armed = false;
    opening = false;
    if (closeWatch) {
      clearInterval(closeWatch);
      closeWatch = 0;
    }
    setFlags(false, false);
    clearLift();
    var ov = document.getElementById('mm-overlay');
    if (ov) ov.classList.remove('open');
    hideFabOnly();
    if (afterPrize) {
      setTimeout(function () {
        try {
          if (window.MMCart && typeof window.MMCart.refresh === 'function') window.MMCart.refresh();
        } catch (e) {}
      }, 400);
    }
  }

  function startCloseWatch() {
    if (closeWatch) clearInterval(closeWatch);
    var misses = 0;
    closeWatch = setInterval(function () {
      if (!armed) return;
      if (gameOpen()) {
        misses = 0;
        return;
      }
      misses++;
      if (misses >= 4) disarm(true);
    }, 300);
  }

  function inactiveMessage() {
    return isAr()
      ? 'عجلة الخصم غير مفعّلة حالياً.'
      : 'Spin & Win is currently disabled.';
  }

  function openWheel() {
    if (opening) return false;
    if (armed && gameOpen()) {
      liftGame();
      return true;
    }

    knownActive = null;
    var active = isWheelActive();
    syncCartWheelBtn(active);
    if (!active) {
      toast(inactiveMessage());
      return false;
    }

    if (document.getElementById('mm-launch-btn') || document.getElementById('mm-overlay')) {
      return openExistingGame();
    }

    /* Widget still mounting — wait for DOM only, no API */
    opening = true;
    setFlags(true, true);
    var tries = 0;
    var wait = setInterval(function () {
      tries++;
      if (document.getElementById('mm-launch-btn') || document.getElementById('mm-overlay')) {
        clearInterval(wait);
        opening = false;
        openExistingGame();
        return;
      }
      if (tries >= 25) {
        clearInterval(wait);
        opening = false;
        setFlags(false, false);
        toast(
          isAr()
            ? 'تعذر تحميل العجلة. حدّث الصفحة.'
            : 'Could not load the wheel. Refresh the page.'
        );
      }
    }, 120);
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!armed) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#mm-close-btn, #mm-close-shop-btn')) {
        setTimeout(function () {
          disarm(true);
        }, 50);
        return;
      }
      if (t.id === 'mm-overlay') {
        setTimeout(function () {
          if (!gameOpen()) disarm(true);
        }, 50);
      }
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && (armed || opening)) disarm(false);
  });

  window.MMWheelLauncher = {
    open: openWheel,
    hide: hideFabOnly,
    scan: function () {
      refreshBtnState();
      hideFabOnly();
    },
    close: function () {
      disarm(false);
    },
    isOpen: function () {
      return armed;
    },
    refresh: refreshBtnState,
    isActive: function () {
      return isWheelActive();
    }
  };

  function boot() {
    syncCartWheelBtn(false);
    refreshBtnState();
    hideFabOnly();
  }

  /* If simple-wheel mounts later, show icon once — no API */
  function watchGameMount() {
    if (!window.MutationObserver || !document.body) return;
    var done = false;
    var obs = new MutationObserver(function () {
      if (done) return;
      if (!domGameReady()) return;
      done = true;
      knownActive = true;
      syncCartWheelBtn(true);
      hideFabOnly();
      try {
        obs.disconnect();
      } catch (e) {}
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      try {
        obs.disconnect();
      } catch (e) {}
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
      watchGameMount();
    });
  } else {
    boot();
    watchGameMount();
  }

  /* One delayed re-check for late widget mount — still no API */
  setTimeout(refreshBtnState, 2500);

  document.addEventListener('cart:updated', function () {
    hideFabOnly();
  });
})();
